import type { FC } from "react";

import { useDraft } from "../../providers/draft-provider";
import { DraftContentForm } from "./draft-content-form";
import { DraftError } from "./draft-error";
import { DrafttNotFound } from "./draft-not-found";
import { DraftSkeleton } from "./draft-skeleton";

export const DraftContent: FC = () => {
  const { draft, isLoading, error } = useDraft();

  if (isLoading) {
    return <DraftSkeleton />;
  }

  if (error) {
    return <DraftError />;
  }

  if (!draft) {
    return <DrafttNotFound />;
  }

  return <DraftContentForm />;
};
